import React from 'react';
import { bool, func } from 'prop-types';

import './price-error.scss';

export const PriceError = ({ refresh, setRefresh }) => {
  return (
    <div className="rental-error">
      <img
        alt=""
        src="https://assets.homedepot-static.com/images/v1/alert-warning-yellow.svg"
        height="23px"
        width="23px"
      />
      <div>
        We&apos;re sorry, something went wrong on our end. <br />
        Please try&nbsp;
        <button
          className="link"
          type="button"
          data-testid="reload-div"
          onClick={() => setRefresh(!refresh)}
        >
          refreshing.
        </button>
      </div>
    </div>
  );
};

PriceError.displayName = 'PriceError';

PriceError.propTypes = {
  refresh: bool.isRequired,
  setRefresh: func.isRequired
};